import {
  Page_Pagebuilder_Blocks_Story,
  Post,
} from '@/graphql/generated/graphql';
import { useLatestPosts } from '@/hooks/useLatestPosts';
import { m } from 'motion/react';
import { containerVariants, itemVariants, viewPort } from 'utils/framer';
import { getContainerClass } from 'utils/helpers';
import PostItem from './PostItem';

const StoryBlock = ({
  blockId,
  containerWidth,
  postsToDisplay,
  heading,
  selectedPosts,
  category,
}: Page_Pagebuilder_Blocks_Story) => {
  const showLatestPosts =
    postsToDisplay !== 'latestCategory' && postsToDisplay !== 'selection';
  const { data: latestPostsData } = useLatestPosts(showLatestPosts);

  const posts =
    postsToDisplay === 'latestCategory' &&
    category?.posts?.nodes &&
    category?.posts?.nodes?.length > 0
      ? category?.posts?.nodes.slice(0, 3)
      : postsToDisplay === 'selection' && selectedPosts?.length > 0
        ? selectedPosts
        : showLatestPosts
          ? (latestPostsData?.posts?.nodes?.slice(0, 3) ?? null)
          : null;
  return (
    <m.section
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      id={blockId ?? undefined}
      className="w-full my-14 lg:my-24"
    >
      <div className={`w-full ${getContainerClass(containerWidth)}`}>
        {heading && <h2 className="mb-4 lg:mb-6">{heading}</h2>}
        {posts && (
          <m.ul
            initial="hidden"
            whileInView="visible"
            viewport={viewPort}
            variants={containerVariants}
            className={`flex flex-col flex-wrap gap-y-8 lg:flex-row lg:w-[calc(100%+24px)] lg:-ml-3`}
          >
            {posts.map((post: Post) => {
              if (!post) return null;
              return (
                <m.li
                  initial="hidden"
                  whileInView="visible"
                  viewport={viewPort}
                  variants={itemVariants}
                  key={post.id}
                  className="basis-1/3 lg:px-3"
                >
                  <PostItem post={post} />
                </m.li>
              );
            })}
          </m.ul>
        )}
      </div>
    </m.section>
  );
};

export default StoryBlock;
